import { createContext, useContext } from 'react'

/**
 * A way to open the Backlog approval from anywhere inside a screen that must
 * not navigate (BRAI-689).
 *
 * Context rather than a prop because the places that need it are leaves: the
 * refusal line inside a single answer card sits four components below the
 * panel that owns the dialog, and threading a callback down to it would put
 * the same prop on three components that have nothing else to do with Backlog.
 *
 * Null outside a provider, which is the honest answer rather than a no-op: a
 * card rendered somewhere with no dialog to open still has to offer the reader
 * a way through, and only it knows what that is.
 */
export const BacklogConnectContext = createContext<(() => void) | null>(null)

/** @returns The opener, or null when there is no dialog on this screen. */
export function useOpenBacklogConnect(): (() => void) | null {
  return useContext(BacklogConnectContext)
}
